import { Home, Info, Users, GraduationCap, CalendarDays, Newspaper, Calendar, ShoppingBag, Phone } from "lucide-react";

export const publicNavigation = [
  { id: "home", label: "ΑΡΧΙΚΗ", path: "/", icon: Home },
  { id: "club", label: "ΣΥΛΛΟΓΟΣ", icon: Info, items: [
    ["about", "Η ιστορία μας", "/about"], ["join", "Γίνε μέλος", "/join"], ["seasons", "Παλαιότερες σεζόν", "/seasons"],
    ["partners", "Συνεργάτες", "/partners"], ["sponsors-team", "Χορηγοί πρώτης ομάδας", "/sponsors/first-team"], ["sponsors-academy", "Χορηγοί ακαδημίας", "/sponsors/academy"],
  ] },
  { id: "team", label: "ΟΜΑΔΑ", icon: Users, items: [
    ["overview", "Πρώτη ομάδα", "/team"], ["roster", "Ρόστερ", "/team?tab=roster"], ["results", "Αποτελέσματα", "/team?tab=results"],
    ["schedule", "Πρόγραμμα", "/team?tab=schedule"], ["gallery", "Γκαλερί", "/team?tab=gallery"], ["venues", "Γήπεδα", "/team?tab=venues"],
    ["trials", "Δοκιμαστικά", "/trials"], ["partners", "Συνεργάτες ομάδας", "/partners?scope=first_team"],
  ] },
  { id: "academy", label: "ΑΚΑΔΗΜΙΑ", icon: GraduationCap, items: [
    ["overview", "Η ακαδημία μας", "/academy"], ["philosophy", "Η φιλοσοφία μας", "/academy/philosophy"],
    ["groups", "Ηλικιακά τμήματα", "/academy/groups"], ["registration", "Εγγραφές αθλητών", "/academy/registration"],
    ["partners", "Συνεργάτες ακαδημίας", "/partners?scope=academy"],
  ] },
  { id: "matches", label: "ΑΓΩΝΕΣ", icon: CalendarDays, items: [
    ["schedule", "Πρόγραμμα αγώνων", "/team?tab=schedule"], ["results", "Αποτελέσματα", "/team?tab=results"],
    ["standings", "Βαθμολογία", "/team?tab=overview"], ["vote", "Παίκτης του μήνα", "/vote"], ["tickets", "Εισιτήρια", "/shop"],
  ] },
  { id: "news", label: "ΝΕΑ", path: "/news", icon: Newspaper },
  { id: "events", label: "ΕΚΔΗΛΩΣΕΙΣ", path: "/events", icon: Calendar },
  { id: "shop", label: "ΚΑΤΑΣΤΗΜΑ", path: "/shop", icon: ShoppingBag },
  { id: "contact", label: "ΕΠΙΚΟΙΝΩΝΙΑ", path: "/contact", icon: Phone },
];